<template>
    <form class="offering-filters" :action="pageUrl" method="get" @submit.prevent>
        <div class="offering-filters__fields">
            <div v-if="months.length" class="offering-filters__field">
                <span
                    id="event-month-filter-label"
                    class="offering-filters__label"
                    @click="focusFilter('event-month-filter')"
                >{{ i18n.month }}</span>
                <EventSelect
                    id="event-month-filter"
                    labelled-by="event-month-filter-label"
                    :model-value="month"
                    :terms="months"
                    :all-label="i18n.allMonths"
                    :clear-label="i18n.clearMonth"
                    :clear-url="clearMonthUrl"
                    :icons="icons"
                    @update:model-value="$emit('update:month', $event)"
                />
            </div>
            <div v-if="categories.length" class="offering-filters__field">
                <span
                    id="event-category-filter-label"
                    class="offering-filters__label"
                    @click="focusFilter('event-category-filter')"
                >{{ i18n.category }}</span>
                <EventSelect
                    id="event-category-filter"
                    labelled-by="event-category-filter-label"
                    :model-value="category"
                    :terms="categories"
                    :all-label="i18n.allCategories"
                    :clear-label="i18n.clearCategory"
                    :clear-url="clearCategoryUrl"
                    :icons="icons"
                    @update:model-value="$emit('update:category', $event)"
                />
            </div>
            <div v-if="category && typeTerms.length" class="offering-filters__field">
                <span
                    id="event-type-filter-label"
                    class="offering-filters__label"
                    @click="focusFilter('event-type-filter')"
                >{{ i18n.type }}</span>
                <EventSelect
                    id="event-type-filter"
                    labelled-by="event-type-filter-label"
                    :model-value="type"
                    :terms="typeTerms"
                    :all-label="i18n.allTypes"
                    :clear-label="i18n.clearType"
                    :clear-url="clearTypeUrl"
                    :icons="icons"
                    @update:model-value="$emit('update:type', $event)"
                />
            </div>
        </div>
        <a
            v-if="hasFilters"
            class="single__filters__reset"
            :href="pageUrl"
            @click.prevent="onReset"
        >
            <span v-html="icons.clearAll"></span>
            {{ i18n.resetFilters }}
        </a>
    </form>
</template>

<script setup>
import { computed, nextTick } from 'vue'

import EventSelect from './EventSelect.vue'

const props = defineProps({
    month: { type: String, default: '' },
    category: { type: String, default: '' },
    type: { type: String, default: '' },
    months: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    hasFilters: { type: Boolean, default: false },
    pageUrl: { type: String, default: '' },
    clearMonthUrl: { type: String, default: '' },
    clearCategoryUrl: { type: String, default: '' },
    clearTypeUrl: { type: String, default: '' },
    icons: { type: Object, default: () => ({}) },
    i18n: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['update:month', 'update:category', 'update:type', 'reset'])

const onReset = () => {
    emit('reset')
    nextTick(() => focusFilter('event-month-filter'))
}

const focusFilter = (id) => {
    const field = document.getElementById(id)

    if (!field) {
        return
    }

    const selection = field.parentElement?.querySelector('.select2-selection')

    if (selection instanceof HTMLElement) {
        selection.focus()
        return
    }

    field.focus()
}

const typeTerms = computed(() => {
    const parent = props.categories.find((item) => item.slug === props.category)

    return parent?.children || []
})
</script>
